import { toCurrency, get, lastDay_st/*, lastDay, lastDay_end*/ } from './helpers';

export default function table(data, number, variables) {
	//var num = new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 2 });
    var tbody = function (number) {
          if (number === 0) {
              return [
                [
					{alignment: "center", text: ""},
					{alignment: "center", text: "Период"},
					/*{alignment: "center", text: "Начислено, руб."},*/
					{alignment: "center", text: "Сумма, руб."},
				
				],
                [
					{text: "Пени"},
					{alignment: "center", text: get.fee(data)},
					/*{alignment: "right"	, text: toCurrency(data.bill.summPfee[0])},*/
					{alignment: "right"	, text: toCurrency(data.bill.summPfeeForPay ? data.bill.summPfeeForPay[0] : data.bill.summPfee[0])},
				
				],
                [
					{text: "Проценты"},
					{alignment: "center", text: get.percent(data)},
				/*	{alignment: "right"	, text: toCurrency(data.bill.summPercent[0])},*/
					{alignment: "right"	, text: toCurrency(data.bill.summPercentForPay ? data.bill.summPercentForPay[0] : data.bill.summPercent[0])},
				
				],
                [
					{alignment: "right", text: "ИТОГО", colSpan: 2},
					{},
				/*	{},*/
					{alignment: "right", text: toCurrency(Number.parseFloat(data.bill.summPfeeForPay ? data.bill.summPfeeForPay[0] : data.bill.summPfee[0]) + Number.parseFloat (data.bill.summPercentForPay ?data.bill.summPercentForPay[0] : data.bill.summPercent[0])) },
				
				]
			];
          } else {
              return [
                [
					{alignment: "center", text: "Наем жилого помещения"},
					{alignment: "center", text: "Период"},
				//	{alignment: "center", text: "Начислено, руб."},
					{alignment: "center", text: "Сумма, руб."},
				],
                [
					{text: "Задолженность"},
					{alignment: "center", text: get.duty(data)},
					//{alignment: "right"	, text: toCurrency(data.bill.balanceOnDateFrom[0])},
					{alignment: "right"	, text: toCurrency(data.bill.balanceOnDateFromForPay ? data.bill.balanceOnDateFromForPay[0] : data.bill.balanceOnDateFromForPay[0])}
				],
                [
					{text: "Перерасчет"},
					//{alignment: "center", text: lastDay(data.bill.dateFrom[0])},
					{alignment: "center", text: lastDay_st(data.bill.dateFrom[0]) + " - " + lastDay_st(data.bill.dateTo[0])},
				//	{alignment: "right"	, text: toCurrency(data.bill.billPoint[number].recalculated[0])},
					{alignment: "right"	, text: "0,00"},
				]
            ];
          } 
        };
    return {
	margin: [-5,0,0,0],
        style: "underNotesSmall",
        table: {
            headerRows: 1,
            widths: [100, 90, 140,5],
			body: 
				tbody(number),
		},
		/*ширина границ ячеек */ 
        layout: {
            hLineWidth: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5; 
            },
            vLineWidth: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
            },
            hLineColor: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? "black" : "black";
            },
            vLineColor: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? "black" : "black";
            }
		},
		
				
    };
};


// WEBPACK FOOTER //
// ./src/pdf_structure_table_new.js